import { useCallback, useContext, useEffect } from "react";
import { RendererContext } from "../contexts/rendererContext";
import { Pole } from "../../../sjorcraft3d/src/objects/pole";
import { useMutation } from "@apollo/client";
import { MOVE_POLE } from "../graphql/gqlProject";
import { useParams } from "react-router-dom";

export const usePoles = () => {
  const rendererContext = useContext(RendererContext);
  const viewer = rendererContext.viewer;
  const [movePole] = useMutation(MOVE_POLE);
  const { projectId } = useParams();

  const onPoleDrop = useCallback(
    ({ pole }: { pole: Pole }) => {
      movePole({
        variables: {
          projectId,
          pole: {
            identifier: pole.identifier,
            position: { ...pole.position },
            direction: { ...pole.direction },
            length: pole.length,
          },
        },
      });
    },
    [viewer, movePole]
  );

  useEffect(() => {
    if (!viewer) return;
    (viewer.scene as any).addEventListener("pole_dropped", onPoleDrop);
    return () => {
      (viewer.scene as any).removeEventListener("pole_dropped", onPoleDrop);
    };
  }, [onPoleDrop, viewer]);
};
